import { Component, OnDestroy, OnInit } from '@angular/core';
import { CompaniesService } from '@services/companies.service';
import { CompanyModel } from '@data-layer/models/companies';
import { ActivatedRoute, Router } from '@angular/router';
import { enumBondRequestState } from '@data-layer/enums/common';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-company-bond-request-edit-page',
  templateUrl: './company-bond-request-edit-page.component.html',
  styleUrls: ['./company-bond-request-edit-page.component.scss'],
})
export class CompanyBondRequestEditPageComponent implements OnInit, OnDestroy {
  public company: CompanyModel;

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(private companiesService: CompaniesService, private router: Router, private activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {
    this.companiesService.companyChange$.pipe(takeUntil(this.isDestroy)).subscribe(() => {
      this.company = this.companiesService.getCompany();
      const isCanEdit: boolean = !this.company.bondRequest || this.company.bondRequest.state !== enumBondRequestState.SENT;
      if (!isCanEdit) {
        this.router.navigate(
          ['/companies', 'bond-request', 'view'],
          this.activatedRoute.snapshot.queryParams['saveParams'] ? { queryParamsHandling: 'merge' } : undefined,
        );
      }
    });
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public afterSaveRequest() {
    this.router.navigate(
      ['/companies', 'bond-request', 'view'],
      this.activatedRoute.snapshot.queryParams['saveParams'] ? { queryParamsHandling: 'merge' } : undefined,
    );
  }
}
